/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Shortcuts_NoteInputs */

const en_fc_tut_shortcuts_note = /** @type {(inputs: Fc_Tut_Shortcuts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the keyboard shortcut editor with Option + Cmd + K (Alt + Ctrl + K on Windows/Linux) to see or remap every key.`)
};

/**
* | output |
* | --- |
* | "Open the keyboard shortcut editor with Option + Cmd + K (Alt + Ctrl + K on Windows/Linux) to see or remap every key." |
*
* @param {Fc_Tut_Shortcuts_NoteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_shortcuts_note = /** @type {((inputs?: Fc_Tut_Shortcuts_NoteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Shortcuts_NoteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_shortcuts_note(inputs)
});
export { fc_tut_shortcuts_note as "fc.tut.shortcuts.note" }